import { createBrowserRouter, RouterProvider as RouterProviderRoot } from 'react-router-dom'

import { protectedRoutes } from 'routes/protectedRoutes'
import { publicRoutes } from 'routes/publicRoutes'

export const RouterProvider = (): JSX.Element => (
  <RouterProviderRoot router={createBrowserRouter([...publicRoutes, ...protectedRoutes])} />
)
